import React, { useEffect, useState } from 'react';
import { FormControl, Box } from '@mui/material';
import Select from 'react-select';
import axios from 'axios';

const GOOGLE_FONTS_API_KEY = process.env.REACT_APP_GOOGLE_FONTS_API_KEY;
const GOOGLE_FONTS_API_URL = `https://www.googleapis.com/webfonts/v1/webfonts?key=${GOOGLE_FONTS_API_KEY}&sort=popularity`;

const FontSelector = ({ settings, segmentHandler }) => {
  const [fonts, setFonts] = useState([]); // Available fonts
  const [previousFont, setPreviousFont] = useState(null); // Track the previously selected font

  useEffect(() => {
    const fetchFonts = async () => {
      try {
        const response = await axios.get(GOOGLE_FONTS_API_URL);
        const fontList = response.data.items.map((font) => ({
          value: font.family,
          label: font.family,
        }));
        setFonts(fontList);
      } catch (error) {
        console.error('Error fetching Google Fonts:', error);
      }
    };
    fetchFonts();
  }, []);

  // Load and remove fonts dynamically in `<head>`
  useEffect(() => {
    if (settings.fontFamily.length > 0) {
      const selectedFont = settings.fontFamily[0]; // Only one font is allowed

      // Remove the previously loaded font
      if (previousFont) {
        const existingFont = document.getElementById(`font-${previousFont}`);
        if (existingFont) {
          existingFont.remove();
        }
      }

      // Load new font
      const fontLink = document.createElement('link');
      fontLink.rel = 'stylesheet';
      fontLink.href = `https://fonts.googleapis.com/css2?family=${selectedFont.replace(/ /g, '+')}:wght@100..900&display=swap&t=${Date.now()}`;
      fontLink.id = `font-${selectedFont}`;

      if (!document.getElementById(`font-${selectedFont}`)) {
        document.head.appendChild(fontLink);
      }

      // Update previous font
      setPreviousFont(selectedFont);
    }
  }, [settings.fontFamily]);

  return (
    <Box>
      <FormControl fullWidth margin="normal">
        <Select
          options={fonts}
          value={fonts.find((f) => f.value === settings.fontFamily[0]) || null} // Only one font selected
          onChange={(selected) =>
            segmentHandler('fontFamily', [selected.value], settings)
          }
          placeholder="Select a font..."
          isSearchable
          styles={{ menu: (base) => ({ ...base, zIndex: 9999 }) }}
        />
      </FormControl>
    </Box>
  );
};

export default FontSelector;
